type PixelEventParams = Record<string, unknown>;

export function trackStandard(event: string, params?: PixelEventParams) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}

export function trackCustom(event: string, params?: PixelEventParams) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('trackCustom', event, params);
}

export function getUtmParams(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  const search = new URLSearchParams(window.location.search);
  const out: Record<string, string> = {};
  for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
    const value = search.get(key);
    if (value) out[key] = value;
  }
  return out;
}
